import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAuthenticatedUser } from '@/components/providers/AuthenticatedUserProvider';
import { Button } from '@/components/ui/button';

import { UpdatePasswordDialog } from './-components/UpdatePasswordDialog';

export const Route = createFileRoute('/_root/my-profile/')({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.profile' }),
  }),
});

function RouteComponent() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { user } = useAuthenticatedUser();

  return (
    <>
      <h1 className="text-3xl mb-6">
        <FormattedMessage id="profile.title" />
      </h1>
      <div className="mb-7 gap-7">
        <h2 className="text-xl">
          <FormattedMessage id="profile.email" />
        </h2>
        <p className="text-l mt-1 text-gray-400">{user.email}</p>
      </div>
      <Button variant="main" onClick={() => setDialogOpen(true)}>
        <FormattedMessage id="profile.updatePassword.title" />
      </Button>

      <UpdatePasswordDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
      />
    </>
  );
}
